module.exports = __webpack_public_path__ + "static/media/beaverton.1f45e1fa.webp";